var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { Typography, useTheme, Fab, Zoom, LinearProgress } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getAll as getAllApi } from '../../../api/warehouseItem';
import { deliveryRequest as deliveryRequestApi } from '../../../api';
import { useWarehouseItemColumns } from '../../../hooks/useColumns';
import { useRequest } from '../../../hooks/requestHook';
import useFetch from '../../../hooks/useFetch';
import MaterialTable from '../../MaterialTable';
import { decamelize } from '../../../utils/camelize';
import { DeliveryRequestIcon } from '../../atoms/Icons';
import PageLayout from '../../atoms/PageLayout';
import FullScreenDialog from '../../molecules/FullScreenDialog';
import DeliveryRequestsEditForm from './DeliveryRequestsEditForm';
import DeliveryRequestsNewForm from './DeliveryRequestsNewForm';
import DeliveryRequestList from './DeliveryRequestList';
import { useRoaster } from '../../../hooks/useRoaster';
import { warehouseItemRowStyle } from '../AdminWarehouseItemsPage';
var TableWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.sp {\n    .table-title {\n      .MuiTypography-h6 {\n        font-size: 12px;\n      }\n      .MuiTypography-caption {\n        font-size: 8px;\n      }\n    }\n\n    table {\n      .MuiSvgIcon-root {\n        font-size: 0.8em;\n      }\n      .MuiSvgIcon-fontSizeLarge {\n        font-size: 1.8em;\n      }\n      th,\n      td {\n        padding: 0 4px;\n\n        &:first-of-type {\n          display: none;\n        }\n      }\n\n      tbody {\n        tr:first-child {\n          input {\n            font-size: 0.8em;\n            min-width: 50px;\n          }\n\n          .MuiSelect-root {\n            font-size: 0.8em;\n            min-width: 30px;\n            padding-right: 5px;\n          }\n        }\n      }\n    }\n  }\n"], ["\n  &.sp {\n    .table-title {\n      .MuiTypography-h6 {\n        font-size: 12px;\n      }\n      .MuiTypography-caption {\n        font-size: 8px;\n      }\n    }\n\n    table {\n      .MuiSvgIcon-root {\n        font-size: 0.8em;\n      }\n      .MuiSvgIcon-fontSizeLarge {\n        font-size: 1.8em;\n      }\n      th,\n      td {\n        padding: 0 4px;\n\n        &:first-of-type {\n          display: none;\n        }\n      }\n\n      tbody {\n        tr:first-child {\n          input {\n            font-size: 0.8em;\n            min-width: 50px;\n          }\n\n          .MuiSelect-root {\n            font-size: 0.8em;\n            min-width: 30px;\n            padding-right: 5px;\n          }\n        }\n      }\n    }\n  }\n"])));
var RoasterWarehouseItemsPage = function () {
    var t = useTranslation().t;
    var location = useLocation();
    var WarehouseItemColumns = useWarehouseItemColumns({ role: 'roaster' });
    var getAll = useRequest(getAllApi);
    var getAllDeliveryRequestApi = useRequest(deliveryRequestApi.getAll);
    var _a = React.useState(false), openDialog = _a[0], setOpenDialog = _a[1];
    var _b = React.useState(), showDeliveryRequests = _b[0], setShowDeliveryRequests = _b[1];
    var _c = React.useState([]), selectedItems = _c[0], setSelectedItems = _c[1];
    var _d = React.useState(), editDeliveryRequests = _d[0], setEditDeliveryRequests = _d[1];
    var tableRef = React.createRef();
    var theme = useTheme();
    var mode = useMediaQuery(theme.breakpoints.down('md')) ? 'sp' : 'pc';
    var roaster = useRoaster().roaster;
    var urlQuery = React.useMemo(function () { return qs.parse(location.search.slice(1)); }, [location.search]);
    var initialPage = parseInt((urlQuery.page || '')) || 0;
    var pageSize = parseInt((urlQuery.pageSize || '')) || 25;
    var defaultFilter = React.useCallback(function (field) {
        var filters = urlQuery.filters || {};
        if (field === 'requestableQuantity' &&
            Object.keys(urlQuery).length === 0) {
            return 'inStock';
        }
        return filters[field];
    }, [urlQuery]);
    var columns = React.useMemo(function () { return [
        WarehouseItemColumns.offerListLink,
        __assign(__assign({}, WarehouseItemColumns.lotNumber), { defaultFilter: defaultFilter('offer.lotNumber'), cellStyle: {
                width: 50,
            } }),
        __assign(__assign({}, WarehouseItemColumns.requestableQuantity), { title: t('pages.roasterWarehouseItems.requestable'), filtering: true, defaultFilter: defaultFilter('requestableQuantity') }),
        __assign(__assign({}, WarehouseItemColumns.deliveringQuantity), { filtering: false, title: t('pages.roasterWarehouseItems.delivering') }),
        __assign(__assign({}, WarehouseItemColumns.deliveredQuantity), { filtering: false, title: t('pages.roasterWarehouseItems.delivered') }),
        __assign(__assign({}, WarehouseItemColumns.endOfStoragePeriod), { filtering: false }),
    ]; }, [t, defaultFilter, WarehouseItemColumns]);
    var handleRequested = React.useCallback(function () {
        if (!tableRef.current)
            return;
        var table = tableRef.current;
        table.onQueryChange();
        setSelectedItems([]);
        setShowDeliveryRequests(undefined);
        setEditDeliveryRequests(undefined);
        setOpenDialog(false);
    }, [tableRef]);
    var handleOpenDialog = React.useCallback(function () {
        setOpenDialog(true);
    }, []);
    var handleCloseDialog = React.useCallback(function () {
        setShowDeliveryRequests(undefined);
        setEditDeliveryRequests(undefined);
        setOpenDialog(false);
    }, []);
    var handleSelectionChange = React.useCallback(function (_, rowData) {
        if (!rowData)
            return;
        var row = rowData;
        if (row.tableData.checked) {
            setSelectedItems(__spreadArray([row], selectedItems, true));
        }
        else {
            setSelectedItems(selectedItems.filter(function (item) { return row.id != item.id; }));
        }
    }, [selectedItems]);
    var handleEditDeliveryRequests = React.useCallback(function (items) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAllDeliveryRequestApi({
                        q: {
                            id_in: items.map(function (_a) {
                                var id = _a.deliveryRequest.id;
                                return id;
                            }),
                            with_status: 'requested',
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    setShowDeliveryRequests(undefined);
                    setEditDeliveryRequests(response === null || response === void 0 ? void 0 : response.data);
                    handleOpenDialog();
                    return [2 /*return*/];
            }
        });
    }); }, [
        getAllDeliveryRequestApi,
        setShowDeliveryRequests,
        setEditDeliveryRequests,
        handleOpenDialog,
    ]);
    var detailPanel = React.useCallback(function (_a) {
        var rowData = _a.rowData;
        return (React.createElement(DeliveryRequestList, { items: rowData.deliveryRequestItems, warehouseItem: rowData, onStartEdit: handleEditDeliveryRequests }));
    }, [handleEditDeliveryRequests]);
    var actions = React.useMemo(function () {
        if (mode === 'pc')
            return [];
        return [
            {
                action: function (rowData) {
                    var deliveryRequestItems = rowData.deliveryRequestItems;
                    return {
                        icon: function () { return React.createElement(DeliveryRequestIcon, null); },
                        tooltip: t('detail'),
                        onClick: function () {
                            setShowDeliveryRequests({
                                warehouseItem: rowData,
                                items: deliveryRequestItems,
                            });
                            setOpenDialog(true);
                        },
                        disabled: deliveryRequestItems.length <= 0,
                    };
                },
                position: 'row',
            },
        ];
    }, [mode, t]);
    var selectionProps = React.useCallback(function (row) {
        return {
            size: mode === 'sp' ? 'large' : 'medium',
            disabled: row.requestableQuantity <= 0 || row.owner == 'typica',
            checked: selectedItems.map(function (item) { return item.id; }).includes(row.id),
        };
    }, [mode, selectedItems]);
    var buildFilterParams = React.useCallback(function (query) {
        var q = {};
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'requestableQuantity':
                    if (filter.value == 'inStock')
                        q.requestable = true;
                    break;
                default:
                    if (filter.column.field) {
                        var field = filter.column.field
                            .split('.')
                            .map(function (e) { return decamelize(e); })
                            .join('_');
                        q["".concat(field, "_cont")] = filter.value;
                    }
                    break;
            }
        });
        return q;
    }, []);
    var buildOrder = React.useCallback(function (order) {
        switch (order) {
            case 'orderItem.offer.lotNumber':
                return 'offers.lot_number';
            default:
                return decamelize(order);
        }
    }, []);
    var fetchWarehouseItems = useFetch({
        buildFilterParams: buildFilterParams,
        api: getAll,
        buildOrder: buildOrder,
    });
    React.useEffect(function () {
        if (!urlQuery.warehouseItemIds)
            return;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, requestableItems;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAll({
                            q: { id_in: urlQuery.warehouseItemIds },
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response)
                            return [2 /*return*/];
                        requestableItems = response.data.filter(function (item) {
                            return item.requestableQuantity > 0 && item.deliveryRequestItems.length === 0;
                        });
                        if (requestableItems.length === 0)
                            return [2 /*return*/];
                        setSelectedItems(requestableItems);
                        setOpenDialog(true);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [urlQuery, getAll]);
    if (!roaster)
        return React.createElement(LinearProgress, null);
    return (React.createElement(PageLayout, { title: t('pages.warehouseItems.title') },
        React.createElement(TableWrapper, { className: mode },
            React.createElement(MaterialTable, { tableRef: tableRef, title: React.createElement("div", { className: "table-title" },
                    React.createElement(Typography, { variant: "h6" }, t('pages.warehouseItems.selectItems')),
                    React.createElement(Typography, { variant: "caption" }, t('pages.warehouseItems.explainationForQuantity'))), model: "warehouseItem", columns: columns, data: fetchWarehouseItems, detailPanel: detailPanel, actions: actions, options: {
                    selection: true,
                    selectionProps: selectionProps,
                    showSelectAllCheckbox: false,
                    showTextRowsSelected: false,
                    filtering: true,
                    paging: !openDialog,
                    initialPage: initialPage,
                    pageSize: pageSize,
                    rowStyle: warehouseItemRowStyle,
                }, onSelectionChange: handleSelectionChange })),
        React.createElement(FullScreenDialog, { title: t('pages.warehouseItems.deliveryRequest'), open: openDialog, onClose: handleCloseDialog },
            showDeliveryRequests && (React.createElement(DeliveryRequestList, { items: showDeliveryRequests.items, warehouseItem: showDeliveryRequests.warehouseItem, onStartEdit: handleEditDeliveryRequests })),
            !showDeliveryRequests && editDeliveryRequests && (React.createElement(DeliveryRequestsEditForm, { roaster: roaster, deliveryRequests: editDeliveryRequests, onSuccess: handleRequested })),
            !showDeliveryRequests &&
                !editDeliveryRequests &&
                selectedItems.length > 0 && (React.createElement(DeliveryRequestsNewForm, { roaster: roaster, warehouseItems: selectedItems, onSuccess: handleRequested }))),
        React.createElement(Zoom, { in: selectedItems.length > 0, timeout: {
                enter: theme.transitions.duration.enteringScreen,
                exit: theme.transitions.duration.leavingScreen,
            }, style: {
                transitionDelay: "".concat(theme.transitions.duration.leavingScreen, "ms"),
                position: 'fixed',
                bottom: 30,
                right: 30,
            }, unmountOnExit: true },
            React.createElement(Fab, { onClick: handleOpenDialog, color: "primary" },
                React.createElement(DeliveryRequestIcon, null)))));
};
export default RoasterWarehouseItemsPage;
var templateObject_1;
